document.addEventListener('DOMContentLoaded', function() {
  // Accordion functionality
  document.querySelectorAll('.accordion__title').forEach(button => {
    button.addEventListener('click', () => {
      const accordionBody = button.nextElementSibling;
      button.classList.toggle('active');
      if (button.classList.contains('active')) {
        accordionBody.style.maxHeight = accordionBody.scrollHeight + 'px';
      } else {
        accordionBody.style.maxHeight = 0;
      }
    });
  });

  const filterCheckboxes = document.querySelectorAll('.filter');
  const clearFiltersButton = document.getElementById('clear-filters');
  const blogItems = document.querySelectorAll('.blog-item');
  const showMoreButton = document.getElementById('show-more');
  let articlesShown = 12;

  filterCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function() {
      filterArticles();
      const liParent = checkbox.closest('li');
      if (checkbox.checked) {
        liParent.classList.add('active');
      } else {
        liParent.classList.remove('active');
      }
    });
  });

  clearFiltersButton.addEventListener('click', clearFilters);

  function filterArticles() {

    showMoreButton.click();
    
    const activeFilters = Array.from(filterCheckboxes)
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.getAttribute('data-filter'));

    let visibleCount = 0;

    if (activeFilters.length === 0) {
      blogItems.forEach((item, index) => {
        item.style.display = index < articlesShown ? '' : 'none';
        if (index < articlesShown) {
          visibleCount++;
        }
      });
      clearFiltersButton.disabled = true;
    } else {
      blogItems.forEach(item => {
        const tags = item.getAttribute('data-tags').split(' ');
        if (activeFilters.some(filter => tags.includes(filter))) {
          if (visibleCount < articlesShown) {
            item.style.display = '';
            visibleCount++;
          } else {
            item.style.display = 'none';
          }
        } else {
          item.style.display = 'none';
        }
      });
      clearFiltersButton.disabled = false;
    }

    toggleShowMoreButton(visibleCount);
  }

  function clearFilters() {
    filterCheckboxes.forEach(checkbox => {
      checkbox.checked = false;
      const liParent = checkbox.closest('li');
      liParent.classList.remove('active');
    });
    articlesShown = 200;
    filterArticles();
  }

  function toggleShowMoreButton(visibleCount) {
    if (visibleCount >= articlesShown) {
      showMoreButton.style.display = 'block';
    } else {
      showMoreButton.style.display = 'none';
    }

    // Check if all blog items are visible, then hide the Show More button
    const allVisible = Array.from(blogItems).every(item => item.style.display === '');
    if (allVisible) {
      showMoreButton.style.display = 'none';
    }
  }

  // Show more functionality
  if (showMoreButton) {
    showMoreButton.addEventListener('click', function() {
      let newlyVisibleCount = 0;
      for (let i = articlesShown; i < articlesShown + 200; i++) {
        if (blogItems[i]) {
          blogItems[i].style.display = '';
          newlyVisibleCount++;
        }
      }
      articlesShown += newlyVisibleCount;

      const visibleItems = Array.from(blogItems).filter(item => item.style.display !== 'none');
      toggleShowMoreButton(visibleItems.length);
    });
  }

  // Initial toggle of Show More button based on initial articles count
  const initialVisibleItems = Array.from(blogItems).filter(item => item.style.display !== 'none');
  toggleShowMoreButton(initialVisibleItems.length);

document.getElementById('show-filters').addEventListener('click', function() {
    // Toggle the 'active' class on the button
    this.classList.toggle('active');
    
    // Toggle the 'active' class on the filter tray
    document.querySelector('.filter-tray').classList.toggle('active');
    
    // Change the button text
    var filterText = this.querySelector('.filter-text');
    if (this.classList.contains('active')) {
        filterText.textContent = 'Hide filters';
    } else {
        filterText.textContent = 'Show filters';
    }
});

  
});
